import { ElementType } from 'react';
import { ImageTagging } from '@/comp/Forms/SiteSurveyForm/RoomConfigurationStep/FormComponents/ImageUpload/components/common';
import { ImagePreviewMobile, ImageSelectMobile } from './components';

type Step = {
  label: string;
  component: ElementType<{ onComplete: () => void; layout: 'mobile' | 'desktop'; loading?: boolean }>;
};

export const MOBILE_STEPS: Step[] = [
  {
    label: 'uploadImageTitle',
    component: ImageSelectMobile,
  },
  {
    label: 'uploadImageTitle',
    component: ImagePreviewMobile,
  },
  {
    label: 'uploadImageTaggingTitle',
    component: ImageTagging,
  },
];
